var render = function render(){var _vm=this,_c=_vm._self._c;return _c('base-form-control',_vm._b({on:{"clear-clicked":_vm.clear}},'base-form-control',_vm.formControlAttributes,false),[_vm._t("prepend"),_c('input',_vm._g(_vm._b({staticClass:"control",attrs:{"disabled":_vm.disabled,"type":"text"},domProps:{"value":_vm.model}},'input',_vm.controlAttributes,false),_vm.listeners)),_vm._t("append")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }